/**
 * Tags
 *
 * @module
 */
var PluginTypes = require('../constants/enums').PluginTypes;

var di = require('../di');
var PluginStore = di.get('stores/plugins');

/**
 * Get appropriate tag locator and apply it
 *
 * @param {ViewTag} tag
 * @returns {*} parsed tag value
 * @throws {module:tags/error.Error} if no locator found for tag.locatorType, or if the locator itself throws
 */
exports.getTagValue = function(tag:ViewTag): any {
  if (__INVARIANT__) {
    require('../utils/invariant').isType('ViewTag', tag);
  }
  var locatorFn = PluginStore.getPlugin(PluginTypes.viewTagLocators, tag.locatorType);
  if (!locatorFn) {
    throw new exports.Error('No locator registered for tag locatorType: ' + tag.locatorType);
  }

  // TODO(tyler): always apply parseValueType?
  return locatorFn(tag);
};

/**
 * See {@link module:tags/enums}
 */
exports.enums = require('./enums');

/**
 * Error to emit when Tag parsing fails
 */
exports.Error = require('./error').Error;
